import React, { useEffect, useState } from "react";

import SectionOne from "./components/SectionOne/SectionOne";
import SectionTwo from "./components/SectionTwo/SectionTwo";
import SectionThree from "./components/SectionThree/SectionThree";
import SectionFour from "./components/SectionFour/SectionFour";
import SectionFive from "./components/SectionFive/SectionFive";
import SectionSix from "./components/SectionSix/SectionSix";
import SectionSeven from "./components/SectionSeven/SectionSeven";
import SectionEight from "./components/SectionEight/SectionEight";
import SectionNine from "./components/SectionNine/SectionNine";
import SectionTen from "./components/SectionTen/SectionTen";
import SectionEleven from "./components/SectionEleven/SectionEleven";
import SectionTwelve from "./components/SectionTwelve/SectionTweleve";

import SideDrawer from "./components/SideDrawer/SideDrawer";
import SectionSpacer from "./components/SectionSpacer/SectionSpacer";
import MapButton from "./components/MapButton/MapButton";
import BreadCrumbs from "./components/BreadCrumbs/BreadCrumbs";

import { placeholderSrc } from "./components/placeholder";

import "react-lazy-load-image-component/src/effects/blur.css";
import "./App.scss";

function App() {
  //const navigate = useNavigate();

  //TODO
  // Map Legened
  // Arrows for slider section 1
  // Section minheight, adjust for various breakpoints
  // legend for map
  // 

  // Kind of Hacky
  const id = window.location.hash.replace("#", "");
  useEffect(() => {
    if (window.location.hash) {
      const element = document.getElementById(id);
      element.scrollIntoView({ block: "start", behavior: "smooth" });
    }
  }, [id]);

  const [show, setShow] = useState(false);

  // Handle Blur overlay when menu is open
  let blurClasses = "blur";
  function handleToggle(current) {
    setShow((current) => !current);
    if (window.location.hash) {
      // navigate("");  //prevents scrolling when map icon is clicked?
    }
  }

  if (show) {
    blurClasses = "blur open";
  } else {
    blurClasses = "blur";
  }

  return (
    <div className="tw-overflow-hidden tw-border-b-2 tw-border-[#c01533]">
      <BreadCrumbs />
      <SideDrawer show={show} change={handleToggle} />
      <MapButton change={handleToggle} />

      <div
        className={`${blurClasses} tw-container tw-relative tw-mx-auto  tw-pb-8`}
      >
        <div className="tw-relative">
          <section id="art-walk-1">
            <SectionOne
              change={handleToggle}
              placeholderSrc={placeholderSrc}
              path="art-walk-1"
            />
            <SectionSpacer />
          </section>

          <section id="art-walk-2">
            <SectionTwo placeholderSrc={placeholderSrc} path="art-walk-2" />
            <SectionSpacer />
          </section>

          <section id="art-walk-3">
            <SectionThree placeholderSrc={placeholderSrc} path="art-walk-3" />
            <SectionSpacer />
          </section>

          <section id="art-walk-4">
            <SectionFour placeholderSrc={placeholderSrc} path="art-walk-4" />
            <SectionSpacer />
          </section>

          <section id="art-walk-5" className="tw-relative">
            <SectionFive placeholderSrc={placeholderSrc} path="art-walk-5" />

            <SectionSpacer />
          </section>

          <section id="art-walk-6">
            <SectionSix placeholderSrc={placeholderSrc} path="art-walk-6" />
            <SectionSpacer />
          </section>

          <section id="art-walk-7">
            <SectionSeven placeholderSrc={placeholderSrc} path="art-walk-7" />
            <SectionSpacer />
          </section>
          <div className="tw-grid xl:tw-grid-cols-3  tw-gap-4 md:first-line:tw-mt-8 md:tw-mb-10">
            <div className="-tw-secondary-gradient lg:tw-w-[89%] xl:tw-w-[100%] tw-mx-auto">
            <div className="tw-pb-[140px] lg:tw-pb-[140px]"></div>
              <section
                id="art-walk-8"
                className="-tw-secondary-gradient tw-mb-[0rem] xl:tw-mb-[2rem]"
              >
                <SectionEight placeholderSrc={placeholderSrc} />
              </section>
            </div>
            <div className="-tw-secondary-gradient lg:tw-w-[89%] xl:tw-w-[100%] tw-mx-auto">
            <div className="tw-pb-[140px] lg:tw-pb-[140px]"></div>
              <section
                id="art-walk-9"
                className="-tw-secondary-gradient tw-mb-[0rem] xl:tw-mb-[2rem]"
              >
                <SectionNine placeholderSrc={placeholderSrc} />
              </section>
            </div>
            <div className="-tw-secondary-gradient lg:tw-w-[89%] xl:tw-w-[100%] tw-mx-auto">
            <div className="tw-pb-[140px] lg:tw-pb-[140px]"></div>
              <section
                id="art-walk-10"
                className="-tw-secondary-gradient tw-mb-[0rem] xl:tw-mb-[2rem]"
              >
                <SectionTen placeholderSrc={placeholderSrc} />
              </section>
            </div>
          </div>
          <SectionSpacer />
          <section id="art-walk-11">
            <SectionEleven placeholderSrc={placeholderSrc} path="art-walk-11" />
            <SectionSpacer />
          </section>

          <section id="art-walk-12">
            <SectionTwelve placeholderSrc={placeholderSrc} path="art-walk-12" />
            <SectionSpacer />
          </section>
        </div>
      </div>
    </div>
  );
}

export default App;
